import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import TicketPayment from 'components/Ticket/TicketPayment'
import Typography from 'components/Typography/Typography'

import './Tickets.scss'
import TicketsHeader from './components/TicketsHeader'
import hocConnect from './hocConnect'

const Tickets = ({ remainingPoints, tickets, isClubMember, disabled, isReservation }) => {
    const intl = useIntl()
    const MAX_NUMBER_PAY_BY_POINTS = 4

    const amount = tickets?.reduce((acc, val) => {
        if (val?.used_points) return acc

        return acc + val?.price
    }, 0)

    return (
        <Container fluid className={'tickets d-flex flex-column'}>
            <TicketsHeader isClubMember={isClubMember} isReservation={isReservation} />
            {tickets?.map((ticket, indx) => {
                const isOverLine = indx >= MAX_NUMBER_PAY_BY_POINTS
                return (
                    <TicketPayment
                        showLine={indx === MAX_NUMBER_PAY_BY_POINTS}
                        key={ticket.seatid}
                        ticket={ticket}
                        isClubMember={isClubMember}
                        isReservation={isReservation}
                        disabledPointPayment={
                            !isClubMember ||
                            disabled ||
                            (!ticket.can_use_points && !ticket.used_points) ||
                            (Number(remainingPoints) < Number(ticket.price) && !ticket.used_points)
                        }
                    />
                )
            })}

            <Container fluid className={'tickets--description'}>
                <Typography variant={'label'} className={'text-nowrap'}>
                    {intl.formatMessage({ id: 'orderSummary.ticketsDescription.totalPrice' })}
                </Typography>
                <span />
                <Typography variant={'pBold'}>
                    {intl.formatMessage({ id: 'orderSummary.ticketsDescription.totalAmount' }, { amount })}
                </Typography>
            </Container>
        </Container>
    )
}

export default hocConnect(Tickets)
